import * as React from 'react';
import { useStores } from 'utility/hooks';
import { Footer, Header } from '@gc/global-components/dist';
import { FailedRequestMessaging, NoApiResponse } from 'components/shared/error-messages';

export const FlightsError = () => {
  const { context, errorStore, analytics } = useStores();
  const { failedRequestMessaging } = errorStore;

  analytics.markPageUsable();

  return (
    <>
      <Header />
      {failedRequestMessaging ? (
        <FailedRequestMessaging flightsActionableErrorMessaging={failedRequestMessaging} />
      ) : (
        <NoApiResponse />
      )}
      <Footer context={context} />
    </>
  );
};
